var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.95,
    height: 16.623,
    viewBox: "0 0 20.95 16.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "discord",
    transform: "translate(-237.525 -1001.688)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-medium-m",
    "data-name": "Icon awesome-medium-m",
    d: "M3.48,7.891a.818.818,0,0,0-.264-.684L1.263,4.851V4.5H7.335l4.7,10.3L16.158,4.5h5.791v.351l-1.672,1.6a.488.488,0,0,0-.186.468V18.7a.488.488,0,0,0,.186.468l1.633,1.6v.351H13.693v-.351l1.693-1.642c.165-.165.165-.217.165-.468V9.143l-4.708,11.95h-.637L4.732,9.143v8.008a1.091,1.091,0,0,0,.3.918l2.2,2.668v.351H1v-.346L3.2,18.07a1.055,1.055,0,0,0,.282-.918Z",
    transform: "translate(236.526 997.188)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.bc7003ae1434cd9fa67a422efd092ef7.svg";
export { ForwardRef as ReactComponent };